import { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import { FileField } from "../../ui-kit";
import { ExportIco, AddIco, DownloadIco } from "../../assets/customIcons";
import { Popup, ICheckbox } from "../../ui-kit";
import { useStatusMessage } from "../../hooks/useStatusMessage";
import allDefectDataStore from "../../store/allDefectData";
import { authStore } from "../../store/authStore";

import {
  HEAT_SUPPLY_KEY,
  COLD_WATER_SUPPLY_KEY,
  GAS_COMMUNICATION_KEY,
  LIGHING_KEY,
  DRAINAGE_KEY,
  POWER_SUPPLY_KEY,
} from "../DefectForm/constants";

import styles from "./Defect.module.scss";
import DefectData from "../../store/defectData";

interface IDefectActionsProps {
  targetStore?: DefectData
}

const DefectActions: FC<IDefectActionsProps> = observer(({targetStore}) => {
  const {
    fillDefectStatus,
    uploadDefectFileIsSending,
    fillDefectError,
    uploadDefectFileIsOpened,
    downloadDedectTemplateIsOpened,
    filterItems,
    downloadDedectTemplate,
    downloadDefectToXls
  } = allDefectDataStore;

  const history = useHistory();
  const { resourceType } = authStore;

  const [checkedColdWaterSupply, setCheckedColdWaterSupply] = useState(false);
  const [checkedDrainage, setCheckedDrainage] = useState(false);
  const [checkedGasCommunication, setCheckedGasCommunication] = useState(false);
  const [checkedHeatSupply, setCheckedHeatSupply] = useState(false);
  const [checkedLighting, setCheckedLighting] = useState(false);
  const [checkedPowerSupply, setCheckedPowerSupply] = useState(false);

  const toggleChecked = () => {
    setCheckedColdWaterSupply(!checkedColdWaterSupply);
    setCheckedDrainage(!checkedDrainage);
    setCheckedGasCommunication(!checkedGasCommunication);
    setCheckedHeatSupply(!checkedHeatSupply);
    setCheckedLighting(!checkedLighting);
    setCheckedPowerSupply(!checkedPowerSupply);
  };

  const onChangeColdWaterSupply = (e) => {
    setCheckedColdWaterSupply(e.target.checked);
    setCheckedDrainage(false);
    setCheckedGasCommunication(false);
    setCheckedHeatSupply(false);
    setCheckedLighting(false);
    setCheckedPowerSupply(false);
  };

  const onChangeDrainage = (e) => {
    setCheckedDrainage(e.target.checked);
    setCheckedColdWaterSupply(false);
    setCheckedGasCommunication(false);
    setCheckedHeatSupply(false);
    setCheckedLighting(false);
    setCheckedPowerSupply(false);
  };

  const onChangeGasCommunication = (e) => {
    setCheckedGasCommunication(e.target.checked);
    setCheckedDrainage(false);
    setCheckedColdWaterSupply(false);
    setCheckedHeatSupply(false);
    setCheckedLighting(false);
    setCheckedPowerSupply(false);
  };

  const onChangeHeatSupply = (e) => {
    setCheckedHeatSupply(e.target.checked);
    setCheckedDrainage(false);
    setCheckedColdWaterSupply(false);
    setCheckedLighting(false);
    setCheckedGasCommunication(false);
    setCheckedPowerSupply(false);
  };

  const onChangeLighting = (e) => {
    setCheckedLighting(e.target.checked);
    setCheckedHeatSupply(false);
    setCheckedDrainage(false);
    setCheckedColdWaterSupply(false);
    setCheckedGasCommunication(false);
    setCheckedPowerSupply(false);
  };

  const onChangePowerSupply = (e) => {
    setCheckedPowerSupply(e.target.checked);
    setCheckedHeatSupply(false);
    setCheckedDrainage(false);
    setCheckedColdWaterSupply(false);
    setCheckedGasCommunication(false);
    setCheckedLighting(false);
  };

  const DEFAULT_CHECKBOX = [
    {
      id: HEAT_SUPPLY_KEY,
      gridTypeId: 1,
      label: "Теплоснабжение",
      checked: checkedHeatSupply,
      onChange: onChangeHeatSupply,
    },
    {
      id: COLD_WATER_SUPPLY_KEY,
      gridTypeId: 2,
      label: "Холодное водоснабжение",
      checked: checkedColdWaterSupply,
      onChange: onChangeColdWaterSupply,
    },
    {
      id: GAS_COMMUNICATION_KEY,
      gridTypeId: 3,
      label: "Газоснабжение",
      checked: checkedGasCommunication,
      onChange: onChangeGasCommunication,
    },
    {
      id: LIGHING_KEY,
      gridTypeId: 4,
      label: "Освещение",
      checked: checkedLighting,
      onChange: onChangeLighting,
    },
    {
      id: DRAINAGE_KEY,
      gridTypeId: 5,
      label: "Водоотведение",
      checked: checkedDrainage,
      onChange: onChangeDrainage,
    },
    {
      id: POWER_SUPPLY_KEY,
      gridTypeId: 6,
      label: "Электроснабжение",
      checked: checkedPowerSupply,
      onChange: onChangePowerSupply,
    },
  ];

  const choices = DEFAULT_CHECKBOX.filter((choice) =>
    resourceType.includes(choice.id),
  );

  const exportDefectTemplate = () => {
    const gridTypeId = checkedHeatSupply 
      ? HEAT_SUPPLY_KEY : checkedColdWaterSupply 
      ? COLD_WATER_SUPPLY_KEY : checkedGasCommunication 
      ? GAS_COMMUNICATION_KEY : checkedLighting 
      ? LIGHING_KEY : checkedDrainage 
      ? DRAINAGE_KEY : checkedPowerSupply && POWER_SUPPLY_KEY;
    downloadDedectTemplate(gridTypeId);
  }

  const handleClickDownDedectTemplate = () => {
    choices.length > 1 
    ? downloadDedectTemplateIsOpened.setTrue()
    : downloadDedectTemplate(choices[0].gridTypeId);
  };
  
  const handleClosePopupDownDedectTemplate = () => {
    allDefectDataStore.closedownloadDedectPopup();
  }; 

  const handleCloseUploadDefectFile = () => {
    allDefectDataStore.closeUploadDefectFile();
  };

  useStatusMessage(fillDefectStatus);

  const onFile = (files) => {
    const formData = new FormData();
    formData.append("file", files[0]);
    allDefectDataStore.uploadDefectFile(formData);
  };

  return (
    <>
      <div className="defect__actions">
        <AddIco
          title="Новый дефект"
          onClick={() => {
            history.push(`/sp/defectform/0`);
          }}
        />
        <DownloadIco 
          title="Выгрузить шаблон для ручного заполнения" 
          onClick={handleClickDownDedectTemplate}
          className={styles.exportDefect}
        />
        <FileField
          label="Загрузить дефект из шаблона"
          onChange={onFile}
          showLabel={false}
          disabled={uploadDefectFileIsSending.value}
        />
        <ExportIco
          title="Экспорт реестра в Excel"
          className={styles.exportDefect}
          onClick={targetStore?.downloadDefectToXls}
        />
      </div>
      <Popup
        open={uploadDefectFileIsOpened.value}
        onClose={handleCloseUploadDefectFile}
        title={"Ошибка обработки файла"}
        className={styles.uploadDefectPopup}
      >
        <div className={styles.uploadDefectContainer}>
          {fillDefectError}
        </div>
      </Popup>
      <Popup
        className={styles.uploadDefectPopup}
        open={downloadDedectTemplateIsOpened.value}
        onClose={handleClosePopupDownDedectTemplate}
        title={"Выгрузить шаблон для ручного заполнения"}
      >
        <div className={styles.uploadDefectPopupContainer}>
          {choices.length > 1 && choices.map((el) => {
            return (
              <ICheckbox
                key={el.id}
                checked={el.checked}
                onChange={el.onChange}
                label={el.label}
                className={styles.uploadDefectPopupCheckbox}
              />
            )
          })}
          {checkedHeatSupply == true
            || checkedColdWaterSupply == true
            || checkedGasCommunication == true
            || checkedLighting == true
            || checkedDrainage == true 
            || checkedPowerSupply == true ?
            <div 
              className={styles.exportDefect} 
              onClick={exportDefectTemplate}
            >
              <DownloadIco />
              <span>Скачать шаблон</span>
            </div>
            : <></>
          }
        </div>
      </Popup>
    </>
  );
});

export default DefectActions;